module.exports = __webpack_public_path__ + "static/media/md-transgender.25a075f4.svg";